export const category = {
    options: 'options',
    project: 'projet',
    parameter: 'parameter',
    principal: 'principal'
}